import { ReactNode } from 'react';

import classNames from 'classnames';

import styles from './ArtifactIcon.module.css';

interface ArtifactIconProps {
  children: ReactNode;
  className?: string;
}

export const ArtifactIcon = ({ children, className }: ArtifactIconProps) => (
  <span className={classNames(styles.root, className)}>{children}</span>
);
